import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ breakpoints }: Theme) => createStyles({
  helpLinkWrapper: {
    display: 'flex',
    verticalAlign: 'bottom',
    flexDirection: 'column-reverse',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    [breakpoints.down(990)]: {
      height: '50%',
    },
  },
  inputWrapper: {
    marginBottom: 30,
  },
  stepModalPaper: {
    '& .MuiDialogContent-root': {
      minHeight: 650,
      maxHeight: '100%',
      display: 'flex',

      [breakpoints.down('sm')]: {
        minHeight: 'auto',
      },
    },
  },
  stepContainer: {
    flexGrow: 1,
  },
}), { name: 'VideoEditStepModal' });

export default useStyles;
